export default "__VITE_ASSET__vOAw0PKx__"